import ControlledInput from "@/components/Common/form/ControlledInput";
import { Button } from "@/components/ui/button";
import {
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Form } from "@/components/ui/form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";

const schema = z.object({
  estimateName: z.string().nonempty("산출 내역서 이름을 입력해주세요"),
});

type Props = {
  onSubmit: (data: { estimateName: string }) => void;
  title?: string;
  label?: string;
  buttonText?: string;
  noLabel?: boolean;
};

export default function EstimateCreateDialog({
  onSubmit,
  title = "산출내역서 이름 설정",
  buttonText = "설정하기",
  noLabel = false,
}: Props) {
  const form = useForm<{ estimateName: string }>({
    defaultValues: {
      estimateName: "",
    },
    resolver: zodResolver(schema),
  });
  const {
    handleSubmit,
    formState: { isValid },
  } = form;

  return (
    <DialogContent className="w-[640px] flex flex-col gap-4">
      <Form {...form}>
        <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-4">
          <DialogHeader>
            <DialogTitle className="text-2xl text-gray-A font-bold">
              {title}
            </DialogTitle>
            <DialogDescription className="text-xs text-gray-B font-normal" />
          </DialogHeader>
          <div>
            <ControlledInput
              name="estimateName"
              label={noLabel ? "" : "산출내역서 이름 설정하기"}
              placeholder="산출 내역서 이름을 설정하세요"
              className="w-full p-3 text-sm font-normal text-gray-A placeholder:border-gray-C placeholder:text-gray-C"
            />
          </div>
          <DialogFooter className="flex flex-row items-center justify-center">
            <Button variant="cancel" size="md" className="rounded-md">
              취소하기
            </Button>
            <Button
              variant="confirm"
              size="md"
              className="rounded-md"
              type="submit"
              disabled={!isValid}
            >
              {buttonText}
            </Button>
          </DialogFooter>
        </form>
      </Form>
    </DialogContent>
  );
}
